// src/components/ConfirmDialog.js

import React, { useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { LanguageContext } from '../contexts/LanguageContext';
import './ConfirmDialog.css';

const ConfirmDialog = ({
  show,
  onHide,
  onConfirm,
  onCancel,
  title,
  message,
  confirmText,
  cancelText,
  variant = 'danger', // danger, warning, info, primary, success
  icon = null,
}) => {
  const { translations } = useContext(LanguageContext);

  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    onHide();
  };

  return (
    <Modal 
      show={show} 
      onHide={handleCancel} 
      centered 
      className={`confirm-dialog variant-${variant}`}
      backdrop="static"
      keyboard={true}
    >
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center">
          {icon && <span className="me-2">{icon}</span>}
          {title || translations.confirmTitle || 'Confirm Action'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">
          {message || translations.confirmMessage || 'Are you sure you want to proceed?'}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          {cancelText || translations.cancel || 'Cancel'}
        </Button>
        <Button variant={variant} onClick={handleConfirm}>
          {confirmText || translations.confirm || 'Confirm'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDialog;
